export default "__VITE_PUBLIC_ASSET__dd0e151a__"